module.exports = __webpack_public_path__ + "img/entrepreship_pending.83ba26ef.png";